//import { uniqueId } from "underscore";
import store from '@/store'
import { uuid } from "vue-uuid"
import axios from 'axios'
import LazyLoad from "vanilla-lazyload"
import Vue from 'vue'
import { HtmlEntitiesMap } from "./htmlEntitiesMap"
import Mark from 'mark.js'



function historyLink(historyItem) {
  loadHandler(null, { name: historyItem.title, target: historyItem.linkTarget, volume: historyItem.volume, setFlag: true })
}


const updateHistory = (historyitem) => {
  // update History 
  store.commit('updateHistory',
    {
      id: uuid.v1(),
      title: historyitem.title,
      linkType: historyitem.linkType,
      linkTarget: historyitem.linkTarget,   
      route: historyitem.route,
      section: historyitem.section,
      tz: historyitem.tz,
      volume: historyitem.volume,
      originator: historyitem.originator,
    })
};

/*** setBrowserBackLink
 *  param hash id
 */
 const  setBrowserBackLink = (id) => {
  if(id || id.length !== 0) {  
    // remove suffix in links in annotations
    const tmpid = id.replace('_anm', '');

    window.location.hash =  tmpid 
  } 
}

function bookClickEventHandler(event) {

  event.preventDefault()
  event.stopPropagation()

  // make this globally available!
  let getNextSibling = function (elem, selector) {

    // Get the next sibling element
    var sibling = elem.nextElementSibling;


    // If there's no selector, return the first sibling
    if (!selector) return sibling

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
      if (sibling.matches(selector)) return sibling
      sibling = sibling.nextElementSibling
    }

  };

  let validateURL = function (url) {
    if (url.indexOf("http://") == 0 || url.indexOf("https://") == 0) {
      return (url)
    }
    else {
      //return ("//" + url);     
      return (url)
    }

  }


  //if not click in infowindow
  if (event.target && typeof event.target.id != 'undefined') {
    if (event.target.id.indexOf('infowindow') === -1) {
      this.$refs.infowindow.style.display = "none"
    }
  }


  if (event.target && event.target.classList.contains('show-note')) {
    var noteId = event.target.getAttribute('id')


    if (noteId.split('-')[0] == "anmerkung") {
      //$('#infowindow-text').html(temp + note);

      let findMe = document.getElementById(noteId)
      let note = getNextSibling(findMe, '.anmerkung')

      document.getElementById("infowindow-text").innerHTML = note.innerHTML  


      let bookwindow = document.getElementById("book-infowindow")
      // $('#book-infowindow').addClass("note").removeClass('variant');
      // $('#book-infowindow').show();
      bookwindow.classList.add("note");
      bookwindow.classList.remove("variant");
      bookwindow.style.display = 'block';

    } else if (noteId.split('-')[0] == "fussnote") {

      let findMe = document.getElementById(noteId)
      let note = getNextSibling(findMe, '.fussnote')     
      document.getElementById("footnote-infowindow-text").innerHTML = note.innerHTML
      let bookwindow = document.getElementById("footnote-infowindow")      
      bookwindow.classList.add("note")
      bookwindow.classList.remove("variant")
      bookwindow.style.display = 'block'

    }
  }
  else if (event.target && event.target.classList.contains('variante-link')) {
    let varId = event.target.getAttribute('data-varid')
    //var variant = $("#" + varId).html();
    var variant = document.getElementById(varId).innerHTML    
    document.getElementById('infowindow-text').innerHTML = variant
    var el = document.getElementById('book-infowindow')
    el.classList.remove("note")
    el.classList.add("variant")
    el.style.display = "block"
  }


  else if (event.target && event.target.classList.contains('pb-druck')) {
    let url = "/pdfs/"
    let tmp = event.target.id.split("-")
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
      url = "//fd.ch.saphir.ch-meta.net/pdfs/"
    }    

    var pdf = '//localhost:8080/pdfs/1_'+ tmp[2] +'.pdf'
    pdf = url + tmp[1] + "_"+ tmp[2] +'.pdf'
    
    //pdf = 'http://localhost:8080/images/Scans/druck/SLA-FD-A-m152_045.jpg'
    window.open(pdf)
  }

  else if (event.target && event.target.classList.contains('extern')) {
    // let varId = event.target.getAttribute('data-varid');
    //window.open(validateURL(event.target.getAttribute("href")), '_blank');
    let url = event.target.getAttribute("href")
    setBrowserBackLink(event.target.parentNode.id) 

    if (url.indexOf("http") == 0 ) {
        window.open(url, '_blank');
    }else {   
        const tempUrl = url.replace(/^\/+/g, '');
        this.$router.push('/' + tempUrl)
    }


/*

    if (url.includes("timeline")||url.includes("stemmata")||url.includes("chrontxtz") ||url.includes("chrontxtz")) {
        // literal string path
        const tempUrl = url.replace(/^\/+/g, '');
        router.push('/' + tempUrl)
         // router.push({ path: '/timeline' })
    }else {
        if (url.indexOf("http") == 0 ) {
            window.open(url, '_blank');
        }else {     
           // window.open("//" + url, '_top');
            window.open("//localhost:8080/" + url, '_top');
        }
    }
 */   
  }

  else if (event.target && event.target.classList.contains('to-ref')) {

    let tz = event.target.dataset.tz
    let section = event.target.getAttribute("data-sec")
    let archiveItem = {
      tz: tz,
      imgIndex: 0,
      txtPageNr: -1,
      txtJumpTarget: "",
      originator: "bookClickEventHandler",
      txtSetFlag: false,
      changeArchive: true
    }
    store.commit('updateArchiveItem', archiveItem)
    let routeName = "archiv"

    //set referring target for browser back link!
    //window.location.hash =  event.target.id 
    setBrowserBackLink(event.target.id) 

    this.$router.push({ name: routeName, params: { id: null, origin: 'search' } }).catch(err => { })
  }

  else if (event.target && (event.target.classList.contains('registerverweis') && event.target.classList.contains('book'))) {
    let target = ""
    if((typeof event.target.dataset.anmerkungsname ) != 'undefined'){
      target = event.target.dataset.anmerkungsname
    }else {
      target = event.target.dataset.name
    }
    if (target == '')  return
    let vol = event.target.dataset.bd

    //set referring target for browser back link!
    setBrowserBackLink(event.target.id) 

    this.$router.push({ 
      name: 'text', 
      hash: "#"+target,
      params: {vol: vol, origin: 'register-bd-5' }}).catch(err => {})

  }


  //else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('online'))) {
  else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('online')) ||
   (event.target.parentNode.classList.contains('verweis') && event.target.parentNode.classList.contains('online'))) 
   {
    let eventelement
    if (event.target.parentNode.classList.contains('verweis')) {
      eventelement = event.target.parentNode
    }else {
      eventelement = event.target
    }

    let fol = (eventelement.dataset.f == null) ? -1 : eventelement.dataset.f
    let target = (eventelement.dataset.name == null) ? '' : eventelement.dataset.name
    let tz = eventelement.dataset.tz

    //updateHistory({ title: tz, linkType: "intern", linkTarget: "", route: null, section: "archiv", tz: tz, originator: "book" })
    let archiveItem = {
      tz: tz,
      imgIndex: 0,
      txtPageNr: fol,
      txtJumpTarget:  target,
      originator: "book",
      txtSetFlag: false,
      changeArchive: true
    }

    this.$nextTick(() => { 
      store.commit('updateArchiveItem', archiveItem)
    })


    //set referring target for browser back link!
    setBrowserBackLink(eventelement.id) 

    //window.location.hash =  event.target.id  

    this.$nextTick(() => { 
            this.$router.push({ name: 'archiv' ,    
            params: {tzRouter: tz , fol: fol, target: target,  origin: 'text' } }).catch(err => {})
    })


  }

  else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('intern'))) {

    let target = "ziel-" + event.target.dataset.name
    let volume = event.target.dataset.bd
    let historytitle = event.target.dataset.name

    //set referring target for browser back link!
    setBrowserBackLink(event.target.id)  

    this.$router.push({ 
        name: 'text', 
        hash: "#"+target,
        params: {vol: volume} })

    updateHistory({ title: historytitle, linkType: "intern", linkTarget: target, route: null, section: "book", tz: null, volume: volume, originator: "book" })

  }




  else if (event.target && (event.target.classList.contains('verweis') && 
  
  (event.target.classList.contains('parallelstelle') 
  || event.target.classList.contains('materialien')
  || event.target.classList.contains('bild')
  ) 
  
  )) {
    const target = "ziel-" + event.target.dataset.name
    const volume = event.target.dataset.bd
    const historytitle = event.target.dataset.name

    store.commit('setBrowserBack', true)   
    //set referring target for browser back link!
    setBrowserBackLink(event.target.id)  

    this.$router.push({ 
      name: 'text', 
      hash: "#"+target,
      params: {vol: volume} }).catch(err => {})
  }

  // dbllnk variant !!!!
  else if (event.target 
       && (event.target.classList.contains('vorhergehend') || event.target.classList.contains('nachfolgend')) 
       && event.target.parentNode.classList.contains('dbllnk')){

    const target = "ziel-" + event.target.dataset.name
    const volume = event.target.dataset.bd
    const historytitle = event.target.dataset.name


    //set referring target for browser back link!
    setBrowserBackLink(event.target.id)   
    
    this.$router.push({ 
    name: 'text', 
    hash: "#"+target,
    params: {vol: volume} }).catch(err => {});
  }


  else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('online'))) {

   // setBrowserBackLink(event.target.id) 
  }

  else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('ton'))) {

    const target = event.target.dataset.name

    //set referring target for browser back link!
    setBrowserBackLink(event.target.id) 

    this.$router.push({ 
      name: 'tondokumente', 
      //hash: "#"+target,
      params: {type: 'sound', id: target} }).catch(err => {});
  }

  else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('film'))) {

    //alert("verweis film")
    //console.log("_______ 7________")
    //setBrowserBackLink(event.target.id) 
  }
  // handle click inside element with class "film"  
  else if (event.target && event.target.closest('.film')) {

    let tmp = event.target.closest('.film')
    const target = tmp.dataset.name
    //set referring target for browser back link!
    setBrowserBackLink(event.target.id)  

    this.$router.push({ 
      name: 'videos', 
      //hash: "#"+target,
      params: {type: 'video', id: target} }).catch(err => {})
  }

  else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('segment'))) {

    let type = "book"
    let target = ""
    let tz = ""
    if((typeof event.target.dataset.tz ) != 'undefined'){
      tz = event.target.dataset.tz
      target = event.target.dataset.name
      type = "online"
    }else {
      target = event.target.dataset.name
    }
    if (target == '')  return

    setBrowserBackLink(event.target.id) 
    if(type == "book") {
      let vol = event.target.dataset.bd
      this.$router.push({ 
      name: 'text', 
      hash: "#"+target,
      params: {vol: vol} }).catch(err => {});

    }else {
      let archiveItem = {
        tz: tz,
        imgIndex: 0,
        txtPageNr: event.target.dataset.f,
        txtJumpTarget: event.target.dataset.name,
        originator: "book",
        txtSetFlag: false,
        changeArchive: true
      }

      this.$nextTick(() => { 
        store.commit('updateArchiveItem', archiveItem)
      })      
  
      this.$nextTick(() => { 
              this.$router.push({ name: 'archiv' ,    
              params: {tzRouter: target , fol: event.target.dataset.f, target: target,  origin: 'text' } }).catch(err => {})
      })

    }
    


  }



  else if (event.target && event.target.classList.contains('intlink')) {
 
    const target = event.target.dataset.intlink

     setBrowserBackLink(event.target.id)    

    this.$router.push({ 
      name: target }).catch(err => {})
  }
  // handle click inside element with class "intanchor"  
  else if (event.target && event.target.closest('.intlink')) {

    const parentTarget =  event.target.closest('.intlink') 
    const target = parentTarget.dataset.intlink;

    setBrowserBackLink(parentTarget.id) 
    this.$router.push({ 
        name: target }).catch(err => {})
  }




  // handle click on element with class "intanchor"
  else if (event.target && event.target.classList.contains('intanchor')) {
    const target = event.target.dataset.intanchor
    //const volume = this.$store.state.activeTexts.actBookVolume;
    const volume = target.substring(0,1)

    //const historytitle = event.target.dataset.name  
     //set referring target for browser back link!
     setBrowserBackLink(event.target.id)    

    this.$router.push({ 
      name: 'text', 
      hash: "#"+target,
      params: {vol: volume} }).catch(err => {})

  }
  // handle click inside element with class "intanchor"  
  else if (event.target && event.target.closest('.intanchor')) {

    const target = event.target.closest('.intanchor').dataset.intanchor;
    //const volume = this.$store.state.activeTexts.actBookVolume;
    const volume = target.substring(0,1)

    //set referring target for browser back link!

    setBrowserBackLink(event.target.id)    
   
    this.$router.push({ 
      name: 'text', 
      hash: "#"+target,
      params: {vol: volume} }).catch(err => {})
  }

  else if (event.target && (event.target.classList.contains('paragraph-marker') || event.target.classList.contains('pagebreak-marker'))) {
    let tipp = event.target.dataset.tooltip
    let temp = "<div>Seitenumbruch:</div>"
    document.getElementById('infowindow-text').innerHTML = tipp;
    let el = document.getElementById('book-infowindow')
    el.classList.remove("note")
    el.classList.add("variant")
    el.style.display = "block"
  }

  else if (event.target && event.target.nodeName.toLowerCase() === 'img') {
    var path = event.target.getAttribute('src');
    // path = path.replace('../images/Scans/','');
    path = path.replace('..', '');
    let pathArray = path.split('/');
    let _tmpIndex = pathArray.indexOf('Scans');
    let _nameOfTextzeuge = pathArray[_tmpIndex + 1];
    // create single image Obj
    let imgObj = [
      {
        type: "image",
        url:
          path
      }
    ]


    // commit image array to store
    store.commit('changeAioImageSet', imgObj)
    this.$refs.textimagetviewer.changeImages(0, "book")
    store.commit('showTextImage', true)

  }
  else if (event.target && event.target.classList.contains('imagelink-pb')) {

    let tzid = event.target.closest("span.pb").getAttribute('data-tz')
    //let src = event.target.getAttribute('id')
    let src = event.target.id
    //const tz = _.find(Vue.AIO.texts, ['name', tzid])
    const tz = _.find(store.state.AIO.texts, ['name', tzid])
    // get all items
    let ActImageArrayAll = tz ? tz.items : []

    if (ActImageArrayAll.length > 0) {

      // create new Array with items that contain the 'imagepath' property
      let ActImageArray = ActImageArrayAll.filter(obj => obj.hasOwnProperty("imagepath"));
      // clean up temp Array
      ActImageArrayAll = []
      const index = ActImageArray.map(e => e.imagepath).indexOf(src)

      let url = "/images/Scans/"
      if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
        //url = "//fd.ch.saphir.ch-meta.net/scans/"
        url = "//fd.ch.saphir.ch-meta.net/scans/"
      }

      // create image array
      const imgObj = _.map(ActImageArray, (value, key) => {
        return {
          //url: 'http://fd.ch.saphir.ch-meta.net/scans/' + value.imagepath, 
          url: url + value.imagepath,
          type: 'image'
        }
      })

      // commit image array to store
      store.commit('changeAioImageSet', imgObj)
      this.$refs.textimagetviewer.changeImages(index, "book")
      store.commit('showTextImage', true)
    }


  }
  else if (event.target && event.target.id == "infowindow-closer") {
    //$("#book-infowindow").hide();
    document.getElementById("book-infowindow").style.display = 'none';
  }
  else if (event.target && event.target.id == "footnote-infowindow-closer") {
    //$("#footnote-infowindow").hide();
    document.getElementById("footnote-infowindow").style.display = 'none';
  }

}


/**** loadHandler
 * 
 * 
 * 
 */


function loadHandler(event, item) {

    document.getElementById("book-infowindow").style.display = 'none';
    document.getElementById("footnote-infowindow").style.display = 'none';

  if (item.volume < 1) return

  if (store.state.activeTexts.actBookVolume == item.volume) {

    jumpToBookSection(event, { itemToLoad: item.target, setFlag: item.setFlag })
    /*
    if(store.state.isBrowserback == false ){ 
      jumpToBookSection(event, { itemToLoad: item.target, setFlag: item.setFlag })
    }else {
      setTimeout(() => {
        document.getElementById("text-container").style.opacity = "1"
        document.getElementById("text-loader").style.display = 'none'
    
      }, 200);
    }*/

  } else {
    loadBook(event, { volume: item.volume, itemToLoad: item.target, setFlag: item.setFlag })
  }
  store.commit('updateActiveTexts', { volume: item.volume, target: item.target, type: 'book' })
  store.commit("setTextIsReady", true) 
}



/*** loadBook
 * 
 * 
 * 
 */

function loadBook(event, data, history) {
  //if( typeof data.volume === 'undefined') {return}

  let doc = "stoffe_" + data.volume + ".html"
  store.commit('updateBooktext', " ")
  let telem = document.getElementById("text-container")
  if (telem) {
    telem.style.opacity = "0"
  }
  let loadelem = document.getElementById("text-container")
  if (loadelem) {
    loadelem.style.display = 'block'
  }
  //document.getElementById("text-container").style.opacity = "0"
  //document.getElementById("text-loader").style.display = 'block'

      
  const baseURI = '/';
  axios.get(baseURI + doc,)
    .then((result) => {
      // close MainNav if open
      store.commit('toggleMainNavState', false)
      //load text reactively

      store.commit('updateBooktext', result.data) 
      const imgtogglerlist = document.querySelectorAll('span.icon-file-text')


      imgtogglerlist.forEach(function (imgtoggler) {
        imgtoggler.addEventListener('click', function (event) {
          event.preventDefault()
          let src = imgtoggler.parentElement.parentElement.getAttribute("data-imgsrc")
          //alert(src)
          event.stopPropagation()
        })
      })

      Vue.nextTick()
        .then(() => {          
          lazyload()
          //checkOverlappingPageNrs()          
          handleMarginItems()      
          jumpToBookSection(event, { itemToLoad: data.itemToLoad, setFlag: data.setFlag })
          highlightSearchResults()  
          
          store.commit('updatePageBreaks',
            document.querySelectorAll(".pb-druck")
           )        
        }) 
    })
  
    
}


function jumpToBookSection(event, target) {

  highlightSearchResults()

  document.getElementById("text-container").style.opacity = "0"
  const id = target.itemToLoad
  const yOffset = -170
  const element = document.getElementById(id)



  // get section of jumpTarget
  if(element) {
    const tmpsection = element.closest('[data-toc="1"]')
    const index = store.state.navStates.bookNavHrefArray.indexOf(tmpsection.id)
    const val = tmpsection.id
    //save index to this.$store.state.activeTexts.actBookTarget

    store.commit('updateActiveTexts', {volume: val.substring(0,1) , section: val, target: id})
  }

  if (element) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
    setTimeout(function () {
      window.scrollTo(0, y)
      setPageNr(element)
    }, 210);


    //if (target.setFlag) {
      // remove all flags first
      document.querySelectorAll('.reference-marker-box').forEach(e => e.remove());
      document.querySelectorAll('.reference-marker').forEach(e => e.remove());
      let newItem = document.createElement("span")
      let flagPositionElement = document.getElementById(id)
      newItem.setAttribute('class', 'reference-marker-box')
      newItem.setAttribute('id', 'pin' + id)
      flagPositionElement.insertBefore(newItem, null);
      let highlightElement = document.createElement("span")              
      highlightElement.setAttribute('class', 'reference-marker')
      element.insertBefore(highlightElement, null);
      


    //} else {
    //  document.querySelectorAll('.reference-marker-box').forEach(e => e.remove());
   // }
  }

  // close MainNav if open
  store.commit('toggleMainNavState', false)



  // with arrow function this is available 
  setTimeout(() => {
    if(document.getElementById("text-container")){
      document.getElementById("text-container").style.opacity = "1"
    }

    if(document.getElementById("text-loader")){
      document.getElementById("text-loader").style.display = 'none'
    }
    
    

  }, 200);
 

}


function lazyload() {
  let lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
  });
}

function highlightSearchResults(){
  let searchtext = store.state.searchText  
  if (searchtext !== "") {
    let context = document.querySelector("#text-container")
    let instance = new Mark(context) 
    instance.unmark({
      "element": "mark",
      "className": "highlight"
    })
    instance.mark(searchtext,{
      "element": "mark",
      "className": "highlight",
      "wildcards": "*",
      "exclude": [
          ".verweis"
      ]
    })
    store.commit('setSearchText', "" )
    store.commit('updateBookSearchTarget',
    {
      vol: 1,
      pgnr: 1,
      searchtext: ""
    })
  }
}


function handleMarginItems() {
  const marginalReferences = document.querySelectorAll('.verweis')
  for (let i = 0; i < marginalReferences.length; i++) {
    // var el = marginalReferences[i].cloneNode(true)
    //el.classList.add('clone')
    //el.innerHTML = el.getAttribute("Randspalte")
    //el.classList.remove('verweis')
    let classList = marginalReferences[i].classList


/*
    if (classList.contains("intext")) {
      let el = marginalReferences[i].cloneNode(true)
      classList.remove('intext')
      el.innerHTML = "<span>" + el.innerHTML + "</span>"
      marginalReferences[i].parentNode.insertBefore(el, marginalReferences[i].nextSibling);
    }
*/

    if (classList.contains("intern")) {
      //marginalReferences[i].classList.add('clone')
      //Zwischenlösung damit alte Notation noch angezeigt wird.
      if (classList.contains("randspalte")) {
        marginalReferences[i].innerHTML = "<span class='ico intern'></span>" + marginalReferences[i].innerHTML

      } else {
        marginalReferences[i].innerHTML = "<span class='ico intern'></span>" + marginalReferences[i].innerHTML

        //marginalReferences[i].innerHTML = "<span class='ico intern'></span>" + marginalReferences[i].getAttribute("randspalte")

      }
    }
    else if (classList.contains("online")) {
      marginalReferences[i].innerHTML = "<span class='ico online'></span>" + marginalReferences[i].innerHTML

    }
    else if (classList.contains("film")) {
      marginalReferences[i].innerHTML = "<span class='ico film'></span>" + marginalReferences[i].innerHTML

    }
    else if (classList.contains("parallelstelle")) {
      if(classList.contains("dbllnk")) { 

        let elprev = marginalReferences[i].getElementsByClassName('vorhergehend')
        let elnext = marginalReferences[i].getElementsByClassName('nachfolgend')
        marginalReferences[i].innerHTML = "<span class='ico parallelstelle'></span>" + marginalReferences[i].innerHTML
        elnext[0].innerHTML +=  "<span>↓</span>"
        elprev[0].innerHTML +=  "<span>↑</span>"

      }else {
        if(classList.contains("nachfolgend")) {
          marginalReferences[i].innerHTML = "<span class='ico parallelstelle'></span>" + marginalReferences[i].innerHTML + "<span>↓</span>"
        }else if (classList.contains("vorhergehend")) {
          marginalReferences[i].innerHTML = "<span class='ico parallelstelle'></span>" + marginalReferences[i].innerHTML + "<span>↑</span>"
        } else {
          marginalReferences[i].innerHTML = "<span class='ico parallelstelle'></span>" + marginalReferences[i].innerHTML
        }

      }




      

    }
    else if (classList.contains("materialien")) {
      marginalReferences[i].innerHTML = "<span class='ico materialien'></span>" + marginalReferences[i].innerHTML

    }
    else if (classList.contains("bild")) {
      marginalReferences[i].innerHTML = "<span class='ico bild'></span>" + marginalReferences[i].innerHTML
    }
    else if (classList.contains("ton")) {
      marginalReferences[i].innerHTML = "<span class='ico ton'></span>"  + marginalReferences[i].innerHTML
      //marginalReferences[i].innerHTML = "<span class='ico ton'></span>" 
    }
    else {
      marginalReferences[i].innerHTML = "<span class='ico online'></span>" + marginalReferences[i].innerHTML
      //marginalReferences[i].classList.add('clone')
    }

    //marginalReferences[i].parentNode.insertBefore(el, marginalReferences[i].nextSibling);

    //marginalReferences[i].insertAfter(el)


  }


}


function highlight(text) {
  if (!this.query) {
    return store.state.bookText;
  }
  var re = HtmlEntitiesEncode(this.query)
  return text.replace(new RegExp(re, "gi"), match => {
    return '<span class="highlightText">' + match + '</span>';

  });
}

function HtmlEntitiesEncode(string) {
  //var entityMap = HtmlEntitiesMap
  string = string.replace(/&/g, '&amp;')
  string = string.replace(/"/g, '&quot;')
  for (var key in HtmlEntitiesMap) {
    var entity = HtmlEntitiesMap[key]
    var regex = new RegExp(key, 'g')
    string = string.replace(regex, entity)
  }
  return string
}

function checkOverlappingPageNrs() {

  const pageNrs = document.querySelectorAll('.pb-druck')
  for (let i = 0; i < pageNrs.length; i++) {

    let e = window.getComputedStyle(pageNrs[i], '::after').top

    if (i % 2) {
      pageNrs[i].style.color = "blue"
      //pageNrs[i].classList.add("left"); 
    }
  }
}

function setPageNr(target){    
    let pageBreaks = store.state.pageBreaks //document.querySelectorAll(".pb-druck")
    let page 
    for (let i = 0; i < pageBreaks.length; ++i) {
        //pageBreaks[i].style.backgroundColor = "green"
        //console.log(pageBreaks)
        //
        //console.log(getOffset(target).top)
        if (pageBreaks[i].offsetTop >  getOffset(target).top) {
            let tmpIdx = (i-1)
            if (i == 0 ) {
                tmpIdx = 0
            }
            page =  pageBreaks[tmpIdx].dataset.n
            store.commit('updateShowPage', page)
            document.getElementById('pagefieldId').value = page            

            break            
        }
    }

}


function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }


export { bookClickEventHandler, historyLink, loadHandler, jumpToBookSection, loadBook, lazyload, highlightSearchResults,setPageNr }